"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNonLatinBasedLanguage = exports.isInternationalLocalization = exports.isInternationalLocalizationFamily = exports.languageCodeFromString = exports.isCartoonsAdditionalLanguageCode = exports.isLanguageCode = exports.isFullLanguageCode = exports.supportedLanguageCodes = exports.nonLatinBasedLanguages = exports.cartoonsAdditionalLanguageCodes = exports.redbullComAdditionalLanguageCodes = exports.rbtvAdditionalLanguageCodes = void 0;
const authorization_model_1 = require("./authorization.model");
exports.rbtvAdditionalLanguageCodes = ['en-EU'];
exports.redbullComAdditionalLanguageCodes = [
    'en-EU',
    'en-MT',
    'he-IL',
    'is-IS',
    'ka-GE',
    'sr-ME',
    'ru-UZ',
    'es-DO',
];
exports.cartoonsAdditionalLanguageCodes = [
    'ar-BH',
    'ar-DZ',
    'ar-JO',
    'ar-KW',
    'ar-LB',
    'ar-MA',
    'ar-OM',
    'ar-QA',
    'ar-SA',
    'ar-TN',
    'el-CY',
    'en-EG',
    'en-HK',
    'en-JM',
    'en-KW',
    'en-LK',
    'en-MT',
    'en-MV',
    'en-NA',
    'en-OM',
    'es-BO',
    'es-CR',
    'es-DO',
    'es-PA',
    'fr-MU',
    'fr-SN',
    'he-IL',
    'is-IS',
    'ka-GE',
    'pt-AO',
    'ru-BY',
    'ru-UZ',
    'sq-KV',
    'sr-ME',
    'sv-SE',
];
exports.nonLatinBasedLanguages = [
    'ar-BH',
    'ar-DZ',
    'ar-EG',
    'ar-JO',
    'ar-KW',
    'ar-LB',
    'ar-MA',
    'ar-MEA',
    'ar-OM',
    'ar-QA',
    'ar-SA',
    'ar-TN',
    'az-AZ',
    'bg-BG',
    'el-CY',
    'el-GR',
    'he-IL',
    'hi-IN',
    'ja-JP',
    'ka-GE',
    'ko-KR',
    'mk-MK',
    'ru-BY',
    'ru-KZ',
    'ru-RU',
    'ru-UZ',
    'sr-RS',
    'th-TH',
    'uk-UA',
    'zh-CN',
    'zh-HK',
    'zh-TW',
];
exports.supportedLanguageCodes = Object.keys(authorization_model_1.userAuthorizationSettings.mappings.locales);
const isFullLanguageCode = (str) => {
    const pattern = /^[a-z]{2}-[A-Z]{2,3}$/;
    return pattern.test(str);
};
exports.isFullLanguageCode = isFullLanguageCode;
const isLanguageCode = (v) => exports.supportedLanguageCodes.includes(v);
exports.isLanguageCode = isLanguageCode;
const isCartoonsAdditionalLanguageCode = (languageCode) => {
    return exports.cartoonsAdditionalLanguageCodes.includes(languageCode);
};
exports.isCartoonsAdditionalLanguageCode = isCartoonsAdditionalLanguageCode;
const languageCodeFromString = (v) => {
    if ((0, exports.isLanguageCode)(v)) {
        return v;
    }
    throw Error(`'${v}' is not a valid language code`);
};
exports.languageCodeFromString = languageCodeFromString;
const isInternationalLocalizationFamily = (languageCode) => {
    return languageCode.length === 2;
};
exports.isInternationalLocalizationFamily = isInternationalLocalizationFamily;
const isInternationalLocalization = (languageCode) => {
    return languageCode.endsWith('-INT');
};
exports.isInternationalLocalization = isInternationalLocalization;
const isNonLatinBasedLanguage = (languageCode) => {
    return exports.nonLatinBasedLanguages.includes(languageCode);
};
exports.isNonLatinBasedLanguage = isNonLatinBasedLanguage;
//# sourceMappingURL=data:application/json;base64,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